/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { ResearchChatControllerCreateSessionMutationRequest, ResearchChatControllerCreateSessionMutationResponse, ResearchChatControllerCreateSession400, ResearchChatControllerCreateSession401, ResearchChatControllerCreateSession404, ResearchChatControllerCreateSession409, ResearchChatControllerCreateSession500 } from "../types/ResearchChatControllerCreateSession.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getResearchChatControllerCreateSessionUrl() {
  const res = { method: 'POST', url: `/api/research-chat` as const }
  return res
}

/**
 * @summary Create new research chat session
 * {@link /api/research-chat}
 */
export async function researchChatControllerCreateSession(data: ResearchChatControllerCreateSessionMutationRequest, config: Partial<RequestConfig<ResearchChatControllerCreateSessionMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ResearchChatControllerCreateSessionMutationResponse, ResponseErrorConfig<ResearchChatControllerCreateSession400 | ResearchChatControllerCreateSession401 | ResearchChatControllerCreateSession404 | ResearchChatControllerCreateSession409 | ResearchChatControllerCreateSession500>, ResearchChatControllerCreateSessionMutationRequest>({ method : "POST", url : getResearchChatControllerCreateSessionUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}